<template>
    <a :href="link" class="community__item">
        <div v-if="category" class="content-cali"> {{category}}</div>
        <img v-if="image" :src="image?.public_path+'?size=small'" :alt="altDescription" class="community__img">
    </a>
</template>
<script>
export default {
    inject: ['locale'],
    props: {
        member: {type: Object, required: true}
    },
    computed: {
        title() {
            return this.member.title
        },
        slug() {
            return this.member.slug
        },
        category() {
            let taxonomies = this.member.taxonomies || []
            if (taxonomies.length == 0) return null

            let category = taxonomies.find(_category => _category.parent_id === 84)
            return category ? category?.multi[this.locale].toUpperCase() : null
        },
        image() {
            return this.member.community_logo
        },
        altDescription() {
            let description = this.locale == 'en' ? 'Community member logo' : 'Logo de miembro de la comunidad'
            return description + this.title
        },
        link() {
            let community = this.locale == 'en' ? 'community' : 'comunidad'
            return `/${this.locale}/${community}/${this.slug}`
        }
    }
}
</script>

<style scoped lang="scss">

</style>